import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import Detail from './components/Detail'
import List from './components/List'
import New from './components/New'

const PromoModule: RouteObject = {
    path: 'promos',
    children: [
        {
            path: '',
            element: <List />,
        },
        {
            path: 'new',
            element: <New />,
        },
        {
            path: ':id',
            element: <Detail />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default PromoModule
